// extracted by mini-css-extract-plugin
module.exports = {"label":"styles_label__3E9DK","title":"styles_title__MX6Fd","verticalLine":"styles_verticalLine__2rrQy"};